import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Link } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import { Button } from "@/components/ui/button";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Classes from "@/pages/Classes";
import Timetable from "@/pages/Timetable";
import Locations from "@/pages/Locations";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Book from "@/pages/Book";
import PrivateLessons from "@/pages/PrivateLessons";
import CostumeHire from "@/pages/CostumeHire";
import PastStudents from "@/pages/PastStudents";
import LandingKidsWhitstable from "@/pages/LandingKidsWhitstable";
import LandingThankYou from "@/pages/LandingThankYou";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminBlog from "@/pages/admin/AdminBlog";
import AdminTimetable from "@/pages/admin/AdminTimetable";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminReviews from "@/pages/admin/AdminReviews";
import AdminHelp from "@/pages/admin/AdminHelp";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const NotFound = () => (
  <div className="py-32 px-4 max-w-3xl mx-auto">
    <p className="font-display uppercase text-8xl sm:text-9xl text-[hsl(var(--kerrys-coral))] leading-none">404</p>
    <h1 className="mt-6 font-display uppercase text-4xl">This page has danced off somewhere</h1>
    <p className="mt-3 text-muted-foreground">Let&rsquo;s get you back to the studio.</p>
    <Button asChild className="mt-8 rounded-none bg-foreground text-background hover:bg-foreground/90 font-bold uppercase tracking-[0.12em] text-xs h-11 px-6">
      <Link to="/" data-testid="notfound-home-link">Back to home</Link>
    </Button>
  </div>
);

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/classes" element={<Classes />} />
            <Route path="/timetable" element={<Timetable />} />
            <Route path="/locations" element={<Locations />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/book" element={<Book />} />
            <Route path="/private-lessons" element={<PrivateLessons />} />
            <Route path="/costume-hire" element={<CostumeHire />} />
            <Route path="/past-students" element={<PastStudents />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/kids-dance-classes-whitstable" element={<LandingKidsWhitstable />} />
          <Route path="/kids-dance-classes-whitstable/thank-you" element={<LandingThankYou />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="blog" element={<AdminBlog />} />
            <Route path="timetable" element={<AdminTimetable />} />
            <Route path="enquiries" element={<AdminEnquiries />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="reviews" element={<AdminReviews />} />
            <Route path="help" element={<AdminHelp />} />
          </Route>
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
